<template>
  <dd-header-card
      v-if="createsSignal"
      header="Signaal instellingen"
      data-dusk="show-signal-settings"
  >
    <dd-card-stacked-list>
      <dd-card-list-row>
        <dd-card-list-item title="Beknopte omschrijving">
          {{ value.signal_title }}
        </dd-card-list-item>
        <dd-card-list-item title="Notitie toevoegen">
          {{ value.signal_description }}
        </dd-card-list-item>
      </dd-card-list-row>

      <dd-card-list-row>
        <dd-card-list-item title="Toewijzen aan gebruiker(s)">
          <user-badge-group-component v-if="hasSignalUsers"
                                      :user-ids="value.signal_assigned_users"></user-badge-group-component>
          <template v-else>
            Geen
          </template>
        </dd-card-list-item>
        <dd-card-list-item title="Toewijzen aan afdeling(en)">
          <user-department-badge-group-component v-if="hasSignalUserDepartments"
                                                 :user-department-ids="value.signal_assigned_user_departments"></user-department-badge-group-component>
          <template v-else>
            Geen
          </template>
        </dd-card-list-item>
      </dd-card-list-row>
      <dd-card-list-row>
        <dd-card-list-item title="Zichtbaar voor klant">
          {{ value.signal_visible_for_customer ? "Ja" : "Nee" }}
        </dd-card-list-item>
        <dd-card-list-item  v-if="value.signal_visible_for_customer" title="Beschrijving voor klant">
          {{ value.signal_customer_description || 'Geen beschrijving' }}
        </dd-card-list-item>
      </dd-card-list-row>
      <dd-card-list-row>
        <dd-card-list-item title="Signalen automatisch verwerken">
          {{ value.signal_auto_process ? "Ja" : "Nee" }}
        </dd-card-list-item>
        <dd-card-list-item  v-if="value.signal_auto_process" title="Beschrijving voor klant">
          {{ value.signal_process_after }} dagen
        </dd-card-list-item>
      </dd-card-list-row>
    </dd-card-stacked-list>
  </dd-header-card>
</template>

<script>
import UserBadgeComponent from "~/modules/user/components/BadgeComponent.vue";
import UserBadgeGroupComponent from "~/modules/user/components/BadgeGroupComponent";
import UserDepartmentBadgeGroupComponent from "~/modules/user_department/components/BadgeGroupComponent";
import EmailAccountBadgeComponent from "~/modules/email_account/components/BadgeComponent";
import productLabelStore from "~/modules/product_label/store";

export default {
  name: "ShowSignalSettingsComponent",
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  components: {
    UserBadgeComponent,
    EmailAccountBadgeComponent,
    UserBadgeGroupComponent,
    UserDepartmentBadgeGroupComponent,
  },
  created() {
    const PRODUCT_LABEL_STORE_KEY = "$_product_label";
    // eslint-disable-next-line no-underscore-dangle
    if (!(PRODUCT_LABEL_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(PRODUCT_LABEL_STORE_KEY, productLabelStore);
    }
  },
  computed: {
    createsSignal() {
      return this.value.create_signal || false;
    },
    hasSignalUsers() {
      return this.value.signal_assigned_users !== null
          && this.value.signal_assigned_users !== undefined
          && this.value.signal_assigned_users.length > 0;
    },
    hasSignalUserDepartments() {
      return this.value.signal_assigned_user_departments !== null
          && this.value.signal_assigned_user_departments !== undefined
          && this.value.signal_assigned_user_departments.length > 0;
    },
  },
  methods: {},
};
</script>


<style scoped>
</style>
